/*
 * Copyright (c) 2024-2026 Nodals AI Ltd
 * All rights reserved.
 */

import { Logger } from '../../../logger';

import type { MediarithmicsConfig } from '../../../types/vendor/mediarithmics';

const logger = Logger.getInstance();
const DEFAULT_STORAGE_KEY: string = 'mics_segments';

class MediarithmicsFacts {
  static get(config: MediarithmicsConfig): string[] {
    if (config?.enabled !== false) {
      if (config?.segments && Array.isArray(config.segments)) {
        return config.segments.map(String);
      }
      const localStorageKey = config?.storageKey ?? DEFAULT_STORAGE_KEY;
      const entry = localStorage.getItem(localStorageKey);
      if (entry) {
        logger.debug('Mediarithmics segment data located in local storage.');
        try {
          const data = JSON.parse(entry);
          if (data?.segments && Array.isArray(data.segments)) {
            return data.segments.map((segment: any) => String(segment.name));
          } else {
            logger.warn('Extracted unexpected Mediarithmics data structure');
          }
        } catch (error) {
          logger.warn(`Error parsing Mediarithmics data: ${error}`);
        }
      }
    }
    return [];
  }
}

export { MediarithmicsFacts };
